import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { hideFavoriteMotivation } from '../../store/favorite_motivation';
import { changeFavoriteAction } from '../../store/offer';
import { FavoriteButton, IFavoriteButtonDispatchProps, IFavoriteButtonStoreProps } from './index';
import { IFastFiltersUserSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';

export const mapStateToProps = (state: IState) => ({
  agent: state.offerData.agent,
  checked: state.offerData.isFavorite,
  isMotivationTooltipShows: state.favoriteMotivation.isShows,
  offer: state.offerData.offer,
  user: (state.offerData.user || { isAuthenticated: false }) as IFastFiltersUserSchema,
});

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  changeFavorite: () => {
    dispatch(changeFavoriteAction());
  },
  hideMotivationTooltip: () => {
    dispatch(hideFavoriteMotivation());
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FavoriteButtonContainer = connect<
  IFavoriteButtonStoreProps,
  IFavoriteButtonDispatchProps,
  Partial<IFavoriteButtonStoreProps>
>(
  mapStateToProps,
  mapDispatchToProps,
)(FavoriteButton);
